class EntityCollection {
  constructor(
    editor,
    type,
    fields,
    parentEid, // optional
    parentField, // optional
  ) {
    this.editor = editor;
    this.type = type;
    this.fields = fields;
    this.parentEid = parentEid;
    this.parentField = parentField;
  }

    htmlId = () => `${this.type}-${this.parentEid}`;

    getEntities = () => this.editor.getEntitiesByTypeAndFields(this.type, this.fields, this.parentEid, this.parentField);

    addEntity = (values) => this.createEntity(values);

    removeEntity = (entity) => {
      this.editor.removeEntity(entity.eid);
    }

    createOrGetEntity = (values) => {
      const entities = this.editor.getEntitiesByTypeAndFields(this.type, { ...this.fields, ...values }, this.parentEid, this.parentField);
      if (entities.length > 0) {
        return entities[0];
      } else {
        return this.createEntity(values);
      }
    }

    createEntity = (values) => {
      const eid = this.editor.addEntity(this.type, {
        ...this.fields,
        ...values,
      }, this.parentEid, this.parentField);
      return this.editor.getEntity(eid);
    }

    getFieldMetadata = (field) => this.editor.getFieldMetadata(this.type, field);
}

export default EntityCollection;
